import React, { FC } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AppNavMenuSelectorProps {
  onMenuClicked: () => void;
}

const AppNavMenuSelector: FC<AppNavMenuSelectorProps> = ({ onMenuClicked }) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" pt={1} sx={{ color: 'black' }} onClick={onMenuClicked}>
      <MenuIcon />
      <Typography>{t('AppNav.menu.menu')}</Typography>
    </Stack>
  );
};

export default AppNavMenuSelector;
